import { HttpResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { AgenciasService } from 'src/app/_services/agencias.service';
import { ToursService } from 'src/app/_services/tours.service';
import { ModalPasajeroEliminadoComponent } from '../modal-pasajero-eliminado/modal-pasajero-eliminado.component';
import { ModalPasajeroConfirmadoComponent } from '../modal-pasajero-confirmado/modal-pasajero-confirmado.component';
import { FileService } from 'src/app/_services/file.service';
import * as fileSaver from 'file-saver';
import { ModalMsgComponent } from '../modal-msg/modal-msg.component';

@Component({
  selector: 'app-pasajero-reservado',
  templateUrl: './pasajero-reservado.component.html',
  styleUrls: ['./pasajero-reservado.component.css']
})
export class PasajeroReservadoComponent implements OnInit, OnDestroy {

  subscriptionPlanilla: Subscription;
  idPasajero: Number;
  idPasajerorecibido: Number;
  pasajeroHabitacion = [];
  datosPasajero = [];
  collapsed = true;
  modalOptions:NgbModalOptions;
  docCargado = [];
  fichaCargada = [];
  
  pasajeroFicha: {
    nombre: string,
    telefono:string,
    email: string,
    tipoDoc: string,
    numerDoc: string,
    observaciones: string,
    imagen: string,
    ficha: string,
    nombreEmergencia: string,
    telefonoEmergencia: string,
    comprobante: string,
    instagram: string,
    facebook: string,
    twitter: string,
    estado: string,
    idReservacion: string,
    tipoHabitacion: string,
    asiento:string
  };

  constructor(
    private agenciasService:AgenciasService,
    private filesService:FileService,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private tourservice: ToursService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnDestroy(): void {
    this.subscriptionPlanilla.unsubscribe();
  }

  ngOnInit(): void {
    /*this.subscriptionPlanilla = this.tourservice.pasajeroReservado.subscribe(result => {
      this.idPasajero = result;
    });*/
    this.subscriptionPlanilla = this.route.queryParams.subscribe(params => {
      if(params.idPasajero){
        
        this.idPasajero = params.idPasajero;
      }
    }
  );
    //obtener documentos
    this.agenciasService.getDocumentos(this.idPasajero).subscribe(data => {
      if(data instanceof HttpResponse) {
        if(data.body !== null && data.body !== undefined && data.body !== ''){
          this.docCargado = data.body;                  
        }        
      }    
    }); 
    //obtener fichas
    this.agenciasService.getFichas(this.idPasajero).subscribe(data => {
      if(data instanceof HttpResponse) {
        if(data.body !== null && data.body !== undefined && data.body !== ''){
          this.fichaCargada = data.body;                  
        }        
      }    
    });  
    this.detallesPasajero()
  }

  detallesPasajero(){  
    this.datosPasajero = [];
    this.agenciasService.pasajeroReservacion(this.idPasajero).subscribe(data => {
      if(data instanceof HttpResponse) {
        if(data.body !== null && data.body !== undefined && data.body !== ''){
          this.datosPasajero = data.body;           
          this.idPasajerorecibido = data.body.id;
          this.pasajeroHabitacion = data.body.id_tipoHabitacion;
          var response = data.body;

        }        
        console.log('el tipo de habitacion reservado es:  ' + data.body.id_tipoHabitacion.id);
        console.log(response.asiento)
        this.pasajeroFicha = {
          nombre: this.getValue(response.nombre_pasajero),
          telefono:this.getValue(response.telefono_pasajero),
          email: this.getValue(response.email_pasajero),
          tipoDoc: this.getValue(response.tipo_documento),
          numerDoc: this.getValue(response.numero_documento),
          observaciones: this.getValue(response.observaciones_pasajero),
          imagen: this.getValue(response.imagen_documento),
          ficha: this.getValue(response.ficha_medica),
          nombreEmergencia: this.getValue(response.nombre_emergencia),
          telefonoEmergencia: this.getValue(response.telefono_emergencia),
          comprobante: this.getValue(response.comprobante),
          instagram: this.getValue(response.instagram_pasajero),
          facebook: this.getValue(response.facebook_pasajero),
          twitter: this.getValue(response.twitter_pasajero),
          estado: this.getValue(response.estado),
          idReservacion: this.getValue(response.id_reservacion),
          tipoHabitacion: this.getValue(response.id_tipoHabitacion),
          asiento: this.getValue(response.asiento),
        }   
      }    
    });    
  }

  getValue(cadena: string){
    return (cadena === null || cadena === undefined || cadena === '')?'-':cadena;
  }


  openModalEliminado() {    
    const modalRef = this.modalService.open(ModalPasajeroEliminadoComponent, { 
      centered: true,  
      backdrop:'static' 
    });   
    this.cancelarPasajero();    
  }

  openModalconfirmado() {    
    const modalRef = this.modalService.open(ModalPasajeroConfirmadoComponent, { 
      centered: true,  
      backdrop:'static' 
    });   
    this.aceptarPasajero();    
  }

  aceptarPasajero(){
    this.agenciasService.aprobarPasajero(this.idPasajerorecibido).subscribe(data => {
      if(data instanceof HttpResponse) {
        if(data.body !== null && data.body !== undefined && data.body !== ''){
          //console.log('pasajero aceptado ' + this.idPasajerorecibido + ' ' + data.body.code);
          //*cambiar el estado de la reservacion a la que pertenece el pasajero, de 1 a 2 (confirmada)
          this.agenciasService.confirmarReservacion(this.pasajeroFicha.idReservacion).subscribe(data => {
            if(data instanceof HttpResponse){
              if(data.body !== null && data.body !== undefined && data.body !== ''){
                console.log('reservacion confirmada ' + this.pasajeroFicha.idReservacion + ' ' + data.body.code);
              }
            }
          });          
        }
        this.router.navigate(['/admin/tours-agencias-reservados']);
      }
    });
   
  }

  cancelarPasajero(){
    this.agenciasService.cancelarPasajero(this.idPasajerorecibido).subscribe(data => {
      if(data instanceof HttpResponse) {
        if(data.body !== null && data.body !== undefined && data.body !== ''){
          //console.log('pasajero cancelado ' + this.idPasajerorecibido + ' ');
        }
        this.router.navigate(['/admin/tours-agencias-reservados']);
      }
    });
    
  }

  redirectTo(uri) {
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() =>
    this.router.navigate([uri]));
  }

  descargarFicha() { 
    if(!this.fichaCargada.length){ //*pasajero no tiene ficha en bd
      const modalRef = this.modalService.open(ModalMsgComponent, { 
        centered: true,  
        backdrop:'static',      
      });
      modalRef.componentInstance.titulo = 'Sin Ficha Médica';
      modalRef.componentInstance.check = 0; 
      modalRef.componentInstance.label = 'Aceptar';
    } else {
        for(let i=0; i<this.fichaCargada.length; i++){
          this.filesService.descargarFicha(this.fichaCargada[i].id).subscribe(response => {
            var blob: any;
            if(response.type === 'application/pdf'){
              blob = new Blob([response], { type: 'application/pdf; charset=utf-8' });              
            }
            else {              
              blob = new Blob([response], { type: response.type });
            }
            const url = window.URL.createObjectURL(blob);
            var ficha = new String( "Ficha Médica "); 
            var nombreFicha = ficha.concat( this.pasajeroFicha.nombre.toString());
			      //window.open(url);
			      //window.location.href = response.url;
			      fileSaver.saveAs(blob, nombreFicha);
        }), error => console.log('Error downloading the file'),
        () => console.info('File downloaded successfully');
        }
    }
  }

  descargarDoc() {
    if(!this.docCargado.length){      
      const modalRef = this.modalService.open(ModalMsgComponent, { 
        centered: true,  
        backdrop:'static',      
      });
      modalRef.componentInstance.titulo = 'Sin Documento';
      modalRef.componentInstance.check = 0; 
      modalRef.componentInstance.label = 'Aceptar';
    } else {
      for(let i=0; i<this.docCargado.length; i++){
        this.filesService.descargarDoc(this.docCargado[i].id).subscribe(response => {         
          //let blob:any = new Blob([response], { type: 'image/jpeg' });
          var blob: any;
          if(response.type === 'application/pdf'){
            blob = new Blob([response], { type: 'application/pdf; charset=utf-8' });              
          }
          else {              
            blob = new Blob([response], { type: response.type });
          }
          const url = window.URL.createObjectURL(blob);
          var doc = new String( "Documento de Identidad " ); 
          var nombreDoc = doc.concat( this.pasajeroFicha.nombre.toString());
          fileSaver.saveAs(blob, nombreDoc); 
        }), error => console.log('Error downloading the file'),
                   () => console.info('File downloaded successfully');

      }
    } 
  }   

}
